// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"29d8b471","961":"c49523a3"}[chunkId] + ".chunk.js";
};